export default "__VITE_ASSET__DAlEXwpk__"